import { render, staticRenderFns } from "./ModalWithdrawHistoryDetail.vue?vue&type=template&id=0b4dcb17&"
import script from "./ModalWithdrawHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./ModalWithdrawHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithdrawHistoryDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports